import backofficeService from '../../api/backoffice'

export default {
  getMesbaAccessKeys() {
    return backofficeService.Api().get('mesba-access-keys')
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  createMesbaAccessKey(data) {
    return backofficeService.Api().post('mesba-access-keys', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  updateMesbaAccessKey(id, data) {
    return backofficeService.Api().put(`mesba-access-keys/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  revokeMesbaAccessKey(id) {
    return backofficeService.Api().post(`mesba-access-keys/${id}/revoke`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getTermCompletion() {
    return backofficeService.Api().get('setting/term-completion')
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  updateTermCompletion(data) {
    return backofficeService.Api().put('setting/term-completion', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get list of categories
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to categories
   */
  getAll(params) {
    return backofficeService.Api().get('business', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        console.log('error on business', error)
        throw error
      })
  },

  /**
   * Get category by id
   * @param {*} params Query Options
   */
  getById(id, params) {
    return backofficeService.Api().get(`business/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  create(data) {
    console.log('here in create', data)
    return backofficeService.Api().post('business', data)
      .then(response => response)
      .catch((error) => {
        console.log('here in error', error)
        throw error
      })
  },
  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`business/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete category
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`business/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
   * Get All businessRights
   * @param {*} params
   
   */

  getAllbusinessRights() {
    return backofficeService.Api().get('businessRightCatalog')
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
  * Get All AccountType
  * @param {*} params
  
  */

  getAllAccountType() {
    return backofficeService.Api().get('api/business/accountType')
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
}
